export const settings = {
  sizes: {
    header: { h: 70 },
    cell: { w: 30, h: 50 },
  },
  bar: {
    prePadding: 15,
    circle: { r: 4, padding: 8 },
    hover: { h: 40 },
    project: { h: 20, fill: '#33A1FB' },
    stage: { h: 13, fill: '#FFD059' },
    task: { h: 13, fill: '#6CD796' },
  },
};

export const colors = {};

export function getX(x) { return x * settings.sizes.cell.w; }
export function getY(y) { return y * settings.sizes.cell.h + settings.sizes.header.h + 30; }

export const xBar = (bar, type = 'start') => (
  type === 'start'
    ? bar.x - settings.bar.circle.padding / 2 - settings.bar.circle.r
    : bar.x + bar.w + settings.bar.circle.padding / 2 + settings.bar.circle.r
);
export const yBar = (bar) => bar.y + settings.bar.hover.h / 2;

export function countArrowPoints(bars) {
  // eslint-disable-next-line
  return bars.map(({ from, to, isStart, id }) => {
    const xStart = xBar(from, isStart ? 'start' : 'finish');
    const yStart = yBar(from);
    const xFinish = xBar(to);
    const yFinish = yBar(to);
    const xPreFinish = xFinish - settings.bar.prePadding;
    const yBetween = yStart > yFinish
      ? to.y - (settings.sizes.cell.h - settings.bar.hover.h) / 2 + settings.sizes.cell.h
      : to.y - (settings.sizes.cell.h - settings.bar.hover.h) / 2;

    const points = xFinish > xStart + settings.bar.prePadding
      ? [
        [xStart, yStart],
        [xStart, yFinish],
        [xFinish, yFinish],
      ]
      : [
        [xStart, yStart],
        [xStart, yBetween],
        [xPreFinish, yBetween],
        [xPreFinish, yFinish],
        [xFinish, yFinish],
      ];

    return { id, points };
  });
}

export function findEdgeDates(data) {
  const allDates = [];
  data.forEach(p => {
    allDates.push(p.dateStart);
    allDates.push(p.dateFinish);

    p.children.forEach(s => {
      allDates.push(s.dateStart);
      allDates.push(s.dateFinish);
    });
  });

  const globalMinDate = new Date(Math.min(...allDates));
  const globalMaxDate = new Date(Math.max(...allDates));
  globalMinDate.setDate(globalMinDate.getDate() - 100);
  globalMaxDate.setDate(globalMaxDate.getDate() + 200);

  return [globalMinDate, globalMaxDate];
}

export function getDiffInHours(refDate, newDate) {
  return (newDate - refDate) / (60 * 60 * 1000);
}

export function validateForLoop(binds, fromId, toId) {
  binds = JSON.parse(JSON.stringify(binds.map(b => [b.from, b.to]))); // eslint-disable-line

  if (fromId === toId) return true;

  const idsToTest = [toId];

  do {
    const currId = idsToTest.pop();

    for (let i = 0; i < binds.length; i += 1) {
      let next = null;
      if (binds[i][0] === currId) {
        next = binds[i][1]; // eslint-disable-line prefer-destructuring
      } else if (binds[i][1] === currId) {
        next = binds[i][0]; // eslint-disable-line prefer-destructuring
      }

      if (!next) {
        continue; // eslint-disable-line no-continue
      }

      if (next === fromId) {
        return true;
      }

      idsToTest.push(next);
      binds.splice(i, 1);
      i -= 1;
    }
  } while (idsToTest.length);

  return false;
}
